export default __webpack_public_path__ + "24fdcad299261ad507968b9ee5ac76df.png";